// CRM layer — the ONE place a client profile gets created from a phone number.
//
// Shared deliberately: the "حفظ العميل" button on a call row and the
// profile step of the start-opportunity flow are the same act, so they run the
// same code. Both write to the CRM `clients` table via PUT /api/clients/:phone.
//
// Rendered inline (not a modal) so callers can place it inside their own modal
// shell — see CrmSaveClientModal and CrmStartOpportunityModal.

import React, { useState } from 'react';
import { crmSaveClient } from './crmApi';

const CrmClientNameForm = ({
  phoneNumber,
  initialName = '',
  note,
  submitLabel = 'حفظ',
  onSaved,
  onCancel,
  autoFocus = true
}) => {
  const [name, setName] = useState(initialName);
  const [city, setCity] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const submit = async () => {
    setError('');
    if (!name.trim()) { setError('اسم العميل مطلوب'); return; }
    setSaving(true);
    try {
      // PUT upserts: it creates the profile if the number has none, and the
      // server backfills anything else it can (e.g. name from the call log).
      const res = await crmSaveClient(phoneNumber, {
        full_name: name.trim(),
        ...(city.trim() ? { city: city.trim() } : {})
      });
      if (onSaved) onSaved(res.data.client);
    } catch (e) {
      setError(e.response?.data?.error || 'فشل حفظ ملف العميل');
      setSaving(false);
    }
  };

  return (
    <div className="crm-scope crm-calm">
      <div className="crm-modal-phone" style={{ textAlign: 'center' }}>
        <div className="num" style={{ textAlign: 'center', fontSize: 17 }}>{phoneNumber}</div>
      </div>

      {note && <p className="crm-modal-note" style={{ fontSize: 13.5, marginBottom: 14 }}>{note}</p>}

      <label className="crm-modal-label">اسم العميل *</label>
      <input className="filter-input" style={{ width: '100%' }} autoFocus={autoFocus}
        placeholder="الاسم الكامل للعميل"
        value={name} onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter') submit(); }} />

      <label className="crm-modal-label" style={{ marginTop: 12 }}>المدينة (اختياري)</label>
      <input className="filter-input" style={{ width: '100%' }}
        value={city} onChange={(e) => setCity(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter') submit(); }} />

      {error && <div className="crm-modal-err" style={{ marginTop: 10, marginBottom: 0 }}>{error}</div>}

      <div style={{ display: 'flex', gap: 8, marginTop: 18 }}>
        <button className="btn btn-primary" disabled={saving || !name.trim()} onClick={submit}>
          {saving ? 'جارٍ الحفظ...' : submitLabel}
        </button>
        {onCancel && <button className="btn btn-outline" onClick={onCancel}>إلغاء</button>}
      </div>

      <p className="crm-faint" style={{ fontSize: 11.5, marginTop: 10 }}>
        يمكنك استكمال بقية البيانات لاحقاً من شاشة «ملفات العملاء».
      </p>
    </div>
  );
};

export default CrmClientNameForm;
